<div
  class="bigdiv"
  [style.padding-top]="
    selectedOption == 'TransactionsForPeriod' ? '35px' : '15px'
  "
>
<div style="text-align: -webkit-right">
  <div class="divoflastdate" *ngIf="!showDatepicker">
      <img [src]="redWarning" alt="redWarning" />
      Last downloaded {{IsDownloaded ? highestEventTSDate : 'NIL'}}
  </div>
</div>
<div class="div row">
  <div
    style="
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 15px;
    "
  >
    <div>
      <h1 class="h1">Transactions</h1>
    </div>
    <div style="display: flex; margin-top: -17px; cursor: pointer">
      <div class="Transctions">
        <input
          type="radio"
          id="html"
          name="fav_language"
          value="TransactionsForPeriod"
          [(ngModel)]="selectedOption"
          (change)="onChange()"
          class="Transctions"
          matTooltip="Transactions for a period"
        />

        <label for="html" style="margin: 5px 5px 5px 5px; cursor: pointer; font-weight: 600;"
          >Transactions for a period</label
        >
      </div>
      <div class="Transctions" style="margin-left: 19px">
        <input
          type="radio"
          id="css"
          name="fav_language"
          value="IncrementalTransactions"
          class="Transctions"
          [(ngModel)]="selectedOption"
          (change)="onChange()"
          matTooltip="Incremental Transactions"
          [disabled]="this.isLoading"

        />

        <label for="css" style="margin: 5px 5px 5px 5px; cursor: pointer; font-weight: 600;"
          >Incremental Transactions</label
        >
      </div>
    </div>
    <label *ngIf="showDatepicker" style="font-weight: 600; font-size: 14px;">From Date:</label>
    <mat-form-field *ngIf="showDatepicker">
      <div style="display: flex; margin-top: -15px; color: gray; justify-content: space-between; cursor: pointer;">
        <input
          matInput
          [matDatepicker]="picker"
          placeholder="From"
          class="custom-input"
          (dateChange)="onDate($event, 'picker')"
          [(ngModel)]="fromDate"
          matTooltip="From Date"
          style="font-weight: 600; font-size: 14px;"
          readonly
        />
        <p class="button" mat-raised-button (click)="picker.open()">
          <img [src]="Calander" alt="Calander" style="margin-top: 10px" />
        </p>
      </div>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    
    <label *ngIf="showDatepicker" style="font-weight: 600; font-size: 14px;">To Date:</label>
    <mat-form-field *ngIf="showDatepicker">
      <div
        style="
          display: flex;
          margin-top: -15px;
          color: gray;
          justify-content: space-between;
          cursor: pointer;
        "
      >
        <input
          matInput
          [matDatepicker]="calander"
          class="custom-input"
          placeholder="To"
          aria-label="To Date"
          [(ngModel)]="toDate"
          (dateChange)="onDate($event, 'calander')"
          readonly
          [matDatepickerFilter]="dateFilter"
          matTooltip="To Date"
          style="font-weight: 600; font-size: 14px;"
        />
        <p class="button" mat-raised-button (click)="calander.open()">
          <img [src]="Calander" alt="Calander" style="margin-top: 10px" />
        </p>
      </div>
      <mat-datepicker #calander></mat-datepicker>
    </mat-form-field>

    <button
      class="view"
      *ngIf="showDatepicker"
      (click)="onViewButtonClick()"
      showError
      [disabled]="!this.fromDate && !this.toDate"
      matTooltip="view"
    >
      View
    </button>
  </div>

  <div
    style="display: flex; padding-right: 25px"
    *ngIf="
      selectedOption === 'TransactionsForPeriod'
        ? transactionData.length > 0
        : incrementalTransctiondata.length > 0
    "
  >
    <p class="Showing" style="margin-top: 13px; font-size: 14px; font-weight: 500;">
      Showing {{ calculateMin() }} to {{ calculateMax() }} of
      {{ calculateTotal() }}
    </p>
    <button class="Download" (click)="downloadExcel()" *ngIf="this.toDate >= this.fromDate" >Download</button>
    <img [src]="Download" alt="Download" class="img" *ngIf="this.toDate >= this.fromDate" />
  </div>
</div>
  <div class="main">
    
    <div
      *ngIf="loading"
      style="display: flex; align-items: center; justify-content: center"
    >
      <mat-spinner diameter="30"></mat-spinner>
      <span style="margin-left: 5px">Downloading...</span>
    </div>
    <div
      *ngIf="spinnerLoading && selectedOption == 'IncrementalTransactions'"
      style="display: flex; align-items: center; justify-content: center"
    >
      <mat-spinner diameter="30"></mat-spinner>
      <span style="margin-left: 5px">Downloading...</span>
    </div>

    <div
      *ngIf="
        selectedOption == 'IncrementalTransactions' &&
        incrementalTransctiondata.length === 0 && !isLoading
      "
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        height: 515px;
        font-size: 17px;
        font-weight: 600;
      "
    >
      No Data available
    </div>
    <div
      *ngIf="!this.isTrue && this.selectedOption === 'TransactionsForPeriod'"
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        height: 515px;
        font-size: 17px;
        font-weight: 600;
      "
    >
      Please click the "View" button to see transactions.
    </div>
    <div
      style="display: flex; align-items: center; justify-content: center"
      *ngIf="
        showImage && selectedOption === 'TransactionsForPeriod'
          ? transactionData.length == 0
          : incrementalTransctiondata.length == 0!
      "
    >
      <div
        *ngIf="
          !isLoading &&
          transactionData.length === 0 &&
          selectedOption == 'TransactionsForPeriod'
        "
      >
        <img
          [src]="checkDataImage()"
          alt="checkDataImage"
          *ngIf="this.isTrue"
          style="width: 515px; height: 515px"
        />
      </div>
    </div>
    <section style="height: auto;" class="example-container mat-elevation-z" tabindex="0">
      <!-- Table component -->
      <div
        *ngIf="isLoading"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          height: 500px;
        "
      >
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
      <table
        mat-table
        [dataSource]="
          selectedOption === 'TransactionsForPeriod'
            ? transactionData
            : incrementalTransctiondata
        "
        matSort
        *ngIf="
          selectedOption === 'TransactionsForPeriod'
            ? transactionData.length > 0 && !isLoading
            : incrementalTransctiondata.length > 0 && !isLoading
        "
        (matSortChange)="onSortChange($event)"
      >
        <!-- Column: 'no' -->
        <ng-container
          matColumnDef="no"
          class="no mat-column-no mdc-data-table__header-cell"
        >
          <th
            mat-header-cell
            *matHeaderCellDef
            class="no mat-column-no mdc-data-table__header-cell mdc-header-cell"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <!-- Column: 'no' -->
            S.No
          </th>
          <td
            mat-cell
            *matCellDef="let element; let i = index"
            class="mdc-data-table__header-cell"
            style="font-size: 12px; font-weight: 600;"
          >
            {{
              selectedOption === "TransactionsForPeriod"
                ? (pageEvent.page - 1) * 10 + i + 1
                : (page - 1) * 10 + i + 1
            }}
          </td>
        </ng-container>
        <ng-container
          matColumnDef="alert"
          class="mat-column-alert mdc-data-table__header-cell"
        >
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="alertSequenceNo"
            mat-sort-header-arrow
            class="mdc-data-table__header-cell"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <div class="mat-sort-header-content">AlertSeqNo</div>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="mdc-data-table__header-cell"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"

          >
            {{ element.alert_sequence_no }}
          </td>
        </ng-container>
        <ng-container
          matColumnDef="tran"
          class="mat-column-tran mdc-data-table__header-cell"
        >
          <th
            mat-header-cell
            *matHeaderCellDef
            style="width: 10vh"
            mat-sort-header
            mat-sort-header="transactionDate"
            aria-label="Button that displays a tooltip when focused or hovered over"
            class="mdc-data-table__header-cell"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <div class="mat-sort-header-content">Tran Date</div>
          </th>
          <td
            class="mdc-data-table__header-cell"
            style="padding-top: 10px"
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"
          >
            {{ element.transaction_date | date : "yyyy-MM-dd hh:mm" }}
          </td>
        </ng-container>
        <ng-container
          matColumnDef="valueDate"
          class="mat-column-valueDate mdc-data-table__header-cell"
          mat-sort-header-arrow
        >
          <th
            class="mdc-data-table__header-cell"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by name"
            mat-sort-header="valueDate"
            aria-label="Button that displays a tooltip when focused or hovered over"
            mat-sort-header-arrow
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <div class="mat-sort-header-content">Value Date</div>
          </th>
          <td
            class="mdc-data-table__header-cell"
            style="padding-top: 10px"
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"
          >
            {{ element.value_date | date : "yyyy-MM-dd" }}
          </td>
        </ng-container>
        <ng-container
          matColumnDef="remiter"
          class="mat-column-remiter mdc-data-table__header-cell"
        >
          <th
            class="mdc-data-table__header-cell"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by name"
            mat-sort-header="remitterAccount"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <div class="mat-sort-header-content">Remitter AcctNo</div>
          </th>
          <td
            class="mdc-data-table__header-cell"
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"
          >
            {{ element.remitter_account }}
          </td>
        </ng-container>
        <ng-container
          matColumnDef="remitername"
          class="mat-column-remitername mdc-data-table__header-cell"
        >
          <th
            class="mdc-data-table__header-cell"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by name"
            mat-sort-header="remitterName"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
            aria-label="Button that displays a tooltip when focused or hovered over"
          >
            <div class="mat-sort-header-content">Remitter Name</div>
          </th>
          <td
            class="mdc-data-table__header-cell"
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"
          >
            {{ element.remitter_name }}
          </td>
        </ng-container>
        <ng-container
          matColumnDef="beneficiary"
          class="mat-column-beneficiary mdc-data-table__header-cell"
        >
          <th
            class="mdc-data-table__header-cell"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Sort by name"
            mat-sort-header="accountNumber"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <div class="mat-sort-header-content">Beneficiary AcctNo</div>
          </th>
          <td
            class="mdc-data-table__header-cell"
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"
          >
            {{ element.account_number }}
          </td>
        </ng-container>

        <ng-container
          matColumnDef="beneficiaryvirtual"
          class="mat-column-beneficiaryvirtual mdc-data-table__header-cell"
        >
          <th
            class="mdc-data-table__header-cell"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="virtualAccount"
            sortActionDescription="Sort by name"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <div class="mat-sort-header-content">Beneficiary VirtualNo</div>
          </th>
          <td
            class="mdc-data-table__header-cell"
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"
          >
            {{ element.virtual_account }}
          </td>
        </ng-container>
        <ng-container
          matColumnDef="debitAmount"
          class="mat-column-debitAmount mdc-data-table__header-cell"
        >
          <th
            class="mdc-data-table__header-cell"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="debitAmount"
            sortActionDescription="Sort by name"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <div class="mat-sort-header-content-right">Debit Amt</div>
          </th>
          <td
            class="mdc-data-table__header-cell"
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"
          >
          <div class="tdColumn">{{ element.debit_amount }}</div>  
          </td>
        </ng-container>
        <ng-container
          matColumnDef="credit"
          class="mat-column-credit mdc-data-table__header-cell"
        >
          <th
            class="mdc-data-table__header-cell"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="creditAmount"
            sortActionDescription="Sort by name"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <div style="padding-left: 1vh">Credit Amt</div>
          </th>
          <td
            class="mdc-data-table__header-cell"
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"
          >
           <div class="tdColumn1">{{ element.credit_amount }}</div> 
          </td>
        </ng-container>
        <ng-container matColumnDef="Remitterbank">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="remitterBank"
            sortActionDescription="Sort by name"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="text-align: left; padding: -3%; font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <div class="mat-sort-header-content">Remitter Bank</div>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"
          >
            {{ element.remitter_bank }}
          </td>
        </ng-container>
        <ng-container
          matColumnDef="cheque"
          class="mat-column-cheque mdc-data-table__header-cell"
        >
          <th
            class="mdc-data-table__header-cell"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="chequeNo"
            sortActionDescription="Sort by name"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <div class="mat-sort-header-content">Cheque No</div>
          </th>
          <td
            class="mdc-data-table__header-cell"
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"
          >
          <div class="tdColumnche">{{ element.cheque_no }}</div>  
          </td>
        </ng-container>
        <ng-container
          matColumnDef="ifsc"
          class="mat-column-ifsc mdc-data-table__header-cell"
        >
          <th
            class="mdc-data-table__header-cell"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="ifsc_code"
            sortActionDescription="Sort by name"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <div class="mat-sort-header-content">IFSC</div>
          </th>
          <td
            class="mdc-data-table__header-cell"
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"
          >
            {{ element.ifsc_code }}
          </td>
        </ng-container>
        <ng-container
          matColumnDef="utr"
          class="mat-column-utr mdc-data-table__header-cell"
        >
          <th
            class="mdc-data-table__header-cell"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="userReferenceNumber"
            sortActionDescription="Sort by name"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <div class="mat-sort-header-content">UTR-RefNo</div>
          </th>
          <td
            class="mdc-data-table__header-cell"
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"
          >
            {{ element.user_reference_number }}
          </td>
        </ng-container>
        <ng-container
          matColumnDef="Trnasactiondescrption"
          class="mat-column-utr mdc-data-table__header-cell"
        >
          <th
            class="mdc-data-table__header-cell"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="transactionDescription"
            sortActionDescription="Sort by name"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <div class="mat-sort-header-content">Narration</div>
          </th>
          <td
            class="mdc-data-table__header-cell"
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"
          >
            {{ element.transaction_description }}
          </td>
        </ng-container>
        <ng-container
          matColumnDef="mnemoniccode"
          class="mat-column-utr mdc-data-table__header-cell"
        >
          <th
            class="mdc-data-table__header-cell"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="mnemonicCode"
            sortActionDescription="Sort by name"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 14px; font-weight: 700; color:rgba(0, 0, 0, 0.7);"
          >
            <div class="mat-sort-header-content">Mnemonic code</div>
          </th>
          <td
            class="mdc-data-table__header-cell"
            mat-cell
            *matCellDef="let element"
            aria-label="Button that displays a tooltip when focused or hovered over"
            style="font-size: 12px; font-weight: 600;"
          >
        {{ element.mnemonic_code }}
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </section>

    <div
      class="pagination-column"
      *ngIf="
        selectedOption === 'TransactionsForPeriod'
          ? transactionData.length > 0
          : incrementalTransctiondata.length > 0
      "
    >
      <div *ngFor="let page of getCustomPageRange()">
        <span class="page">
          <div>
            <button
              (click)="onPageClick(page)"
              class="pagination"
              [ngClass]="{ active: isCurrentPage(page) }"
            >
              {{ page }}
            </button>
          </div>
        </span>
        <ng-container
          *ngIf="page !== getCustomPageRange()[getCustomPageRange().length - 1]"
        >
          <ng-template #ellipsis>
            <span>... </span>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</div>
